/* src/components/quantify-supplement-project-library-item-modal/quantify-supplement-project-library-item-modal.component.scss */
:host {
  display: block;
  --modal-header-footer-height: 5rem;
}
.form__wrapper {
  height: var(--vwui-modal--max-height);
  flex-direction: column;
}
.form__fixed-part {
  flex-grow: 0;
  flex-shrink: 0;
  height: var(--modal-header-footer-height);
}
.form__fixed-part-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 5rem;
  padding: 0 var(--vwui-size-spacing-lg);
}
.form__content {
  flex: 1 1 auto;
  overflow: auto;
  height: calc(100% - 2 * var(--modal-header-footer-height));
}
.form__fixed-part--fade {
  position: relative;
}
.form__fixed-part--fade::before {
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 2rem;
  top: -2rem;
  background:
    linear-gradient(
      to bottom,
      transparent,
      #fff);
}
vwui-modal-header .modal-title {
  width: 100%;
}
.library-item__top {
  flex: 1;
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.library-item__title {
  font-size: 1.125rem;
  font-weight: var(--vwui-font-weight-semibold);
  color: var(--vwui-color-dark);
  max-width: 900px;
  width: 90vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.remarks-logbook {
  vertical-align: top;
}
.remarks-logbook--multiline {
  white-space: normal;
  word-wrap: break-word;
}
.remarks-logbook__created {
  color: var(--vwui-color-neutral-1);
  font-size: var(--vwui-size-font-sm);
  font-weight: var(--vwui-font-weight-semibold);
  padding-top: var(--vwui-size-spacing-xs);
}
.add-button {
  vertical-align: top;
  display: inline-block;
  margin-bottom: 1.5rem;
}
.financial-impact-table {
  display: flex;
}
.financial-impact-table--cell {
  padding: 16px;
}
.financial-impact-table--cell:first-child {
  padding-left: 0px;
}
/*# sourceMappingURL=quantify-supplement-project-library-item-modal.component-KC7AZ6XO.css.map */
